export default __webpack_public_path__ + "static/media/person_2.065f120e.png";